import React, { useCallback, useMemo } from 'react'
import { useRouter } from '../../../../utils/helper'
import ListPage from '../../../components/templates/ListPage'
import * as paths from '../../../constants/path'
import Button from '../../../components/common/Button'
import Text from '../../../components/common/Text'
import dayjs from 'dayjs'
import styled from '@emotion/styled'
import { useGetAllArticle } from '../../../services/article/article-query'
import { Chip } from '@material-ui/core'
import { Authorize } from '../../../components/Authorize'
import { ROLE } from '../../../services/user/user-typed'
import { appConfig } from '../../../constants/app-config'

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding-right: 16px;
`
const ButtonStyled = styled(Button)`
  padding: 7px 13px;
`

const ArticleList = () => {
  const { push, query } = useRouter()
  const { data: articleData } = useGetAllArticle({ page: query.page, q: query.q })
  const { items, meta } = articleData || {}

  const onViewClick = useCallback(
    record => {
      const routeParam: any = {
        id: record.id,
      }

      push(paths.articleDetail({ routeParam }))
    },
    [push],
  )

  const onCreateClick = useCallback(
    record => {
      push(paths.createArticle())
    },
    [push],
  )

  const columns = useMemo(() => {
    return [
      {
        title: 'Title',
        dataIndex: 'title',
      },
      { title: 'Author', dataIndex: 'authorName' },
      {
        title: 'Status',
        dataIndex: 'isActive',
        render: (text: string, record: { isActive: boolean }) => {
          const { isActive } = record
          return isActive ? (
            <Chip label="Active" color="primary" style={{ color: 'white' }} />
          ) : (
            <Chip label="Inactive" variant="outlined" color="default" />
          )
        },
      },
      {
        title: 'Last Modified Date',
        dataIndex: 'updatedAt',
        render: (text: string, record: { updatedAt: string }) => {
          const { updatedAt } = record
          return <Text>{dayjs(updatedAt).format('D MMMM  YYYY HH:mm ')}</Text>
        },
      },
      {
        title: 'Publish Date',
        dataIndex: 'publishDate',
        render: (text: string, record: { publishDate: string }) => {
          const { publishDate } = record
          return publishDate ? (
            <Text>{dayjs(publishDate).format('D MMMM  YYYY HH:mm ')}</Text>
          ) : (
            <Text>{`Not published yet`}</Text>
          )
        },
      },
      {
        title: '',
        dataIndex: 'action',
        render: (text: string, record: {}) => (
          <Button onClick={() => onViewClick(record)}>View</Button>
        ),
      },
    ]
  }, [onViewClick])

  const setQueryParam = useCallback(
    params => {
      push(paths.article({ queryParam: { ...query, ...params } }))
    },
    [push, query],
  )
  const onSearch = useCallback(
    text => {
      setQueryParam({ q: text, page: 1 })
    },
    [setQueryParam],
  )
  const onPageChange = useCallback(
    page => {
      setQueryParam({ page })
    },
    [setQueryParam],
  )

  return appConfig.ENABLE_FEATURE_ARTICLE ? (
    <Authorize role={ROLE.ADMIN}>
      <ListPage
        topbar={
          <Layout>
            <Authorize role={ROLE.MANAGER}>
              <ButtonStyled variant="warning" onClick={onCreateClick}>
                Create
              </ButtonStyled>
            </Authorize>
          </Layout>
        }
        tableProps={{
          columns,
          data: items,
          onPageChange,
          pagination: {
            currentPage: meta?.currentPage || 0,
            itemCount: meta?.itemCount || 0,
            itemsPerPage: meta?.itemsPerPage || 0,
            totalItems: meta?.totalItems || 0,
            totalPages: meta?.totalPages || 0,
          },
        }}
        searchInputProps={{ onSearch, value: query.q, placeholder: 'Search name or Author' }}
      />
    </Authorize>
  ) : (
    <></>
  )
}

export default ArticleList
